import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/user",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "user-list",
        component: () =>
          import("@/views/UserManagement/UserManagementPage.vue"),
        meta: {
          title: "User Management",
          titleLocalizationCode: "User_Management",
          desc: "User management page",
          descLocalizationCode: "User_Management_Page",
          sidebarElement: false,
          isRequireAuthorization: true,
          permissionCode: "User.Read",
        },
        props: { logoFileName: null },
      },
      {
        path: "/user/add",
        name: "user-add",
        component: () =>
          import("@/views/UserManagement/UserManagementAddPage.vue"),
        meta: {
          title: "User Management",
          titleLocalizationCode: "User_Management",
          desc: "User management page",
          descLocalizationCode: "User_Management_Page",
          sidebarElement: false,
          isRequireAuthorization: true,
          permissionCode: "User.Add",
        },
        props: { logoFileName: null },
      },
      {
        path: "/user/edit",
        name: "user-edit",
        component: () =>
          import("@/views/UserManagement/UserManagementEditPage.vue"),
        meta: {
          title: "User Management",
          titleLocalizationCode: "User_Management",
          desc: "User management page",
          descLocalizationCode: "User_Management_Page",
          sidebarElement: false,
          isRequireAuthorization: true,
          permissionCode: "User.Edit",
        },
        props: { logoFileName: null },
      },
      {
        path: "/user/user-profile",
        name: "user-profile",
        component: () =>
          import("@/views/UserManagement/UserProfile.vue"),
        meta: {
          title: "User Profile",
          titleLocalizationCode: "User_Profile",
          desc: "User profile page",
          descLocalizationCode: "User_Profile_Page",
          sidebarElement: false,
          isRequireAuthorization: true,
          permissionCode: "User.Edit",
        },
        props: { logoFileName: null },
      },
    ],
  },
];
